var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.4991C23 5.1478 17.8513 -0.000921249 11.5 -0.000921249C5.14872 -0.000921249 0 5.1478 0 11.4991C0 17.2391 4.20538 21.9966 9.70312 22.8594V14.8233H6.7832V11.4991H9.70312V8.96549C9.70312 6.0833 11.42 4.49127 14.0468 4.49127C15.305 4.49127 16.6211 4.71588 16.6211 4.71588V7.54595H15.171C13.7424 7.54595 13.2969 8.43242 13.2969 9.34186V11.4991H16.4863L15.9765 14.8233H13.2969V22.8594C18.7946 21.9966 23 17.2391 23 11.4991Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFacebook);
export default __webpack_public_path__ + "static/media/login-facebook.445769b1516a4d30146174cf08fe71ce.svg";
export { ForwardRef as ReactComponent };